{
    "name": "Test",
    "key": "T",
    "production": false,
    "apiBaseUrl": "https://testapi.praticko.it/bu-rest/rest/ecommerce/",
    "apiBaseUrlWA": "https://testapi.praticko.it/bu-rest/rest/webapp/",
    "apiBaseUrlDL": "https://testapi.praticko.it/bu-rest/rest/download/",
    "apiBaseUrlQBS": "https://testapi.praticko.it/bu-rest/rest/qbs/"
  }